module.exports = __webpack_public_path__ + "media/images/DigitalPlatforms-aaf882813240f84c10e4a72de61c8016.svg";